import { ModuleContainerWidget } from "./ModuleContainerWidget/widget";

export const EEWidgets = [ModuleContainerWidget];
